import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba72745e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "book-info" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "info-detail" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "탑승일", -1 /* HOISTED */))
const _hoisted_5 = { class: "info-content board-date" }
const _hoisted_6 = { class: "info-detail line-info" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "탑승노선", -1 /* HOISTED */))
const _hoisted_8 = { class: "info-content" }
const _hoisted_9 = { class: "line-route-name" }
const _hoisted_10 = { class: "info-detail" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "탑승위치", -1 /* HOISTED */))
const _hoisted_12 = { class: "info-content" }
const _hoisted_13 = { class: "info-detail" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-title" }, "차량정보", -1 /* HOISTED */))
const _hoisted_15 = { class: "info-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString($setup.dayjs($props.boardInfo.realGetOnDateTime).format("YYYY-MM-DD(dd)")), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode($setup["LineTypeChip"], {
            lineTypeCode: $props.boardInfo.lineTypeCode,
            lineTypeName: $props.boardInfo.lineTypeName,
            isSmallSize: true
          }, null, 8 /* PROPS */, ["lineTypeCode", "lineTypeName"]),
          _createElementVNode("p", _hoisted_9, _toDisplayString($setup.useGetLineRouteName(
                $props.boardInfo.lineTypeCode,
                $props.boardInfo.lineRouteName,
                $props.boardInfo.lineRouteNo
              )) + " " + _toDisplayString($props.boardInfo.firstStopTime), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", null, _toDisplayString($props.boardInfo.realGetOnBusStopName ?? "-"), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", null, _toDisplayString($setup.busInfoText), 1 /* TEXT */)
        ])
      ])
    ])
  ]))
}